import { FC } from 'react';

import {
  ImageWithTextSideBySideSlice,
  ImageWithTextSideBySideSliceWithFeaturesList,
} from '@/types';
import { useFilteredSliceItemsByLocationSlug } from '@/hooks';
import { HeadingAsParagraph } from '@/utils';
import { asText } from '@prismicio/helpers';
import {
  DefaultComponentSection,
  textAlign,
} from '../ImageWithTextSideBySide.components';

import style from './withfeatureslistvariation.module.scss';
import { PrismicImageWithAlt } from '@/components/PrismicImageWithAlt';

export const WithFeaturesListVariation: FC<{
  slice: ImageWithTextSideBySideSliceWithFeaturesList &
    ImageWithTextSideBySideSlice;
}> = ({ slice }) => {
  const { filteredItems } = useFilteredSliceItemsByLocationSlug(slice?.items);

  const title = asText(slice.primary.feature_title);

  return (
    <DefaultComponentSection slice={slice}>
      {title && (
        <HeadingAsParagraph
          className={style.feature__title}
          color={slice.primary.feature_title_color as string}
          field={slice.primary.feature_title}
        />
      )}
      {filteredItems?.length > 0 && (
        <div className={style.items_section}>
          {filteredItems?.map((item, index) => (
            <div className={style.item} key={index}>
              {slice.primary.list_icon.url && (
                <figure
                  className={style.image}
                  style={{
                    alignSelf: textAlign(
                      slice.primary.content_horizontal_align as string,
                    ),
                  }}
                >
                  <PrismicImageWithAlt
                    defaultAlt="Decoration icon"
                    field={slice.primary.list_icon}
                  />
                </figure>
              )}
              {item.feature_text && (
                <p
                  className={style.title}
                  style={{
                    color: slice.primary.feature_description_color as string,
                  }}
                >
                  {item.feature_text}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </DefaultComponentSection>
  );
};
